/* eslint-disable jsx-a11y/iframe-has-title */

import React, { useEffect, useRef, useState } from 'react'

import { Button } from 'primereact';
import { useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';

import { isMobile } from "react-device-detect";
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf'


import { toastShow } from '../../../../Base/Services/ToastService';
import Loader from '../../../../Base/Components/Loader/Loader';

import { getArchivoMemoToken, getMemoToken } from '../../../../API/Gerencia/Comunicados/ComunicadosRequests';
import headerPng from '../../../../Assets/Membrete/header.jpg'
import footerPng from '../../../../Assets/Membrete/footer.jpg'
import RobertoB from '../../../../Assets/Firmas/RobertoB.png'

import { styles } from "./ComunicadoStyles"

import { getPersonalToken } from '../../../../API/RRHH/Personal/PersonalRequests';
import { getSeccionesToken } from '../../../../API/RRHH/Secciones/SeccionesRequests';
import { getPosicionesToken } from '../../../../API/RRHH/Posiciones/PosicionesRequests';
import { getFechaFormatoLarge } from '../../../../Base/Services/Moment/Luxon';

import { firmas } from '../../../../Services/Firmas/FirmasService';

import './ComunicadoPDFStyles.scss'

const ComunicadoPDF = ({ memoDist, setReadyToSend = () => {} }) => {


    let params = useParams();

    const [memo, setMemo] = useState(memoDist ? memoDist?.Memo : params?.memo)



    const noEditables = [3588, 3596]

    const [loading, setLoading] = useState(true);
    const toast = useRef()
    const token = process.env.REACT_APP_TokenMemo;


    const [memoInfo, setMemoInfo] = useState(null);
    const [personas, setpersonas] = useState([]);
    const [secciones, setSecciones] = useState([]);
    const [firma, setFirma] = useState([]);
    const [anexos, setAnexos] = useState([]);
    const [posiciones, setPosiciones] = useState([]);

    const [pdf, setPdf] = useState('');
    const [blob, setBlob] = useState(null);


    const getInfo = async () => {
        if (memo) {
            const p = await getPersonalToken(token);
            console.log({p});
            setpersonas(p);
            const s = await getSeccionesToken(token);
            setSecciones(s)
            const ps = await getPosicionesToken(token);
            setPosiciones(ps)
            const m = await getMemoToken(memo, token)
            if (m.length > 0) {
                setMemoInfo(m[0])
                const files = await getArchivoMemoToken(m[0].idMemo, token)
                setAnexos(files)
                getPersonaEnvia(m[0], p)
                setTimeout(() => {
                    click(m[0]);
                    setLoading(false);
                    setReadyToSend(true);
                }, 1500);
            } else {
                setMemoInfo(null)
                toastShow(toast, 'error', 'Memorándum no encontrado')
            }
        }
    }

    const getPersonaEnvia = async (memoInfo, personas) => {

        let firmasT = []

        if (memoInfo.Permiso1) {
            const f = firmas.filter(e => e.idUser === memoInfo.IdUsuarioPermiso1)
            if (f.length > 0) {
                console.log({f});
                console.log({personas});
                const p = personas?.filter(e => e.idpersonal === f[0]?.idpersonal)
                if (p.length > 0) {
                    firmasT.push({ ...p[0], firma: f })
                }
            }
        }
        if (memoInfo.Permiso2) {
            const f = firmas.filter(e => e.idUser === memoInfo.IdUsuarioPermiso2)
            if (f.length > 0) {
                const p = personas.filter(e => e.idpersonal === f[0].idpersonal)
                if (p.length > 0) {
                    firmasT.push({ ...p[0], firma: f })
                }
            }
        }
        if (memoInfo.Permiso3) {
            const f = firmas.filter(e => e.idUser === memoInfo.IdUsuarioPermiso3)
            if (f.length > 0) {
                const p = personas.filter(e => e.idpersonal === f[0].idpersonal)
                if (p.length > 0) {
                    firmasT.push({ ...p[0], firma: f })
                }
            }
        }

        if (memoInfo.PermisoPresidencia) {
            const f = firmas.filter(e => e.idUser === memoInfo?.IdUsuarioPermisoPresidencia)
            if (f.length > 0) {
                const p = personas.filter(e => e.idpersonal === f[0].idpersonal)
                if (p.length > 0) {
                    firmasT.push({ ...p[0], firma: f })
                }
            }
        }

        setFirma(firmasT)
    }

    const setDe = () => {
        const dest = memoInfo.Envia.split(',')
        if (memoInfo?.TipoEnvia === 0) {
            const p = personas.filter(e => dest.includes(e.idpersonal))
            return (p.map(e => e.NombreEmpleado)).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
        if (memoInfo?.TipoEnvia === 1) {
            const p = secciones.filter(e => dest.includes(e.IdSeccion + ''))
            return (p.map(e => e.Seccion)).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
    }

    const setPara = () => {
        const dest = memoInfo.Destinatario.split(',')
        if (memoInfo?.TipoDestinatario === 0) {
            const p = personas.filter(e => dest.includes(e.idpersonal))
            return (p.map(e => e.NombreEmpleado)).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
        if (memoInfo?.TipoDestinatario === 1) {
            const p = secciones.filter(e => dest.includes(e.CodigoSeccion + ''))
            return (p.map(e => e.Seccion)).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
        if (memoInfo?.TipoDestinatario === 2) {
            return (memoInfo.Destinatario).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
        if (memoInfo?.TipoDestinatario === 3) {
            return 'Personal ' + ('PPF.').toUpperCase()
        }
        if (memoInfo?.TipoDestinatario === 4) {
            const p = posiciones.filter(e => dest.includes(e.CodigoPosicion + ''))
            return (p.map(e => e.Posicion)).toString().toLowerCase().replaceAll(',', ', ') + '.'
        }
    }


    const click = async (memoInfo) => {
        // Guarda el PDF

        const doc = new jsPDF({
            unit: 'pt',
            format: 'letter',
            compress: true,
            putOnlyUsedFonts: true
        });
        document.getElementById('toPDF').innerHTML = memoInfo?.Contenido;


        const a = await doc.html(document.getElementById('Comunicado'), {
            margin: [100, 50], // [110, 60]
            filename: memoInfo?.Memo + '.pdf',
            callback: async(doc) => {
                const pageCount = doc.internal.getNumberOfPages();
                const pageSize = doc.internal.pageSize;


                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                    const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                    const footer = `${i} / ${pageCount}`;
                    doc.addImage(headerPng,"JPEG",
                        20, 15, pageWidth - 60, 85,undefined, 'FAST')
                    doc.addImage(footerPng, "JPEG",
                        58, pageHeight - 75, pageWidth - 115, 45, undefined, 'FAST')
                    doc.text(footer, pageWidth - 70, pageHeight - 85, { baseline: 'bottom' });


                    if (!noEditables.includes(memoInfo?.IdEstado)) {
                        doc.setFontSize(150);
                        doc.text('Borrador', 100, 200, {
                            baseline: 'bottom',

                            angle: -45,
                            renderingMode: 'stroke'
                        });
                        doc.setFontSize(12);
                    }
                }
                    setPdf(doc.output('bloburl'));
                    setBlob(doc.output('blob'));
            }
        });
    }


    const descargar = () => {
        if (blob) {
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                // IE workaround for "blob" support
                window.navigator.msSaveBlob(blob, memo);
            } else {
                // Use FileSaver.js library for download
                const blob2 = new Blob([blob], { type: 'application/pdf' });
                saveAs(blob2, memo);
            }
            toastShow(toast, 'success', 'Descargando')
        }
    }

    useEffect(() => {
        getInfo()
    }, [memo])


    useEffect(() => {
        setMemo(memoDist?.Memo)
    }, [memoDist])




    return (
        <div>
            <Toast ref={toast} />
            {/* <h2>{isMobile + ''}</h2> */}
            {loading && <div id='loadingCont' style={{ width: '100vw', height: '100vh', border: '1px solid #ccc' }} >
                <h1>Cargando...</h1>
                <Loader show={true} querySelector={'#loadingCont'} />
            </div>}
            {isMobile ? <div style={{ width: '100vw', height: '100vh', border: '1px solid #ccc', justifyContent: 'center', alignItems: 'center', display: 'flex' }} className='dflex'>
                <Button label={blob === null ? 'Cargando...' : 'Descargar'} onClick={descargar} loading={blob === null} icon={'pi pi-download'} />
            </div>
                :
                <iframe src={pdf}  style={{ width: '100vw', height: '100vh', border: '1px solid #ccc' }} />}

{/* 5.133in */}
            <div id='Comunicado' style={{ maxWidth: '5.34in', color: 'black'}}> 
                {memoInfo ? (<div>
                    <div>
                        <div style={styles.header} className='headerContainer'>
                            <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                <div className='Correlativo'>
                                    <span style={styles.memoTitulo}>Comunicado Informativo </span>
                                    <div style={{ marginTop: 5 }}>{memoInfo?.Memo}</div>
                                </div>
                            </div>
                            <div>
                                <div style={styles.memoInfoRow}>
                                    <span style={styles.memoInfo}>De: </span>
                                    <span style={styles.memoInfoValue}>{setDe()}</span>
                                </div>
                                <div style={styles.memoInfoRow}>
                                    <span style={styles.memoInfo}>Para: </span>
                                    <span style={styles.memoInfoValue}>{setPara()}</span>
                                </div>
                                <div style={styles.memoInfoRow}>
                                    <span style={styles.memoInfo}>Fecha: </span>
                                    <span style={styles.memoInfoValue}>{getFechaFormatoLarge(memoInfo.FechaTable)}.</span>
                                </div>
                                <div style={styles.memoInfoRow}>
                                    <span style={styles.memoInfo}>Asunto: </span>
                                    <span style={styles.memoInfoValue}>{memoInfo.Asunto}</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            {memoInfo?.TipoInformativo === 0 && <p style={{ marginBottom: 10, ...styles.text }}>
                                {memoInfo.Introduccion ? memoInfo.Introduccion : ''}
                            </p>}

                            <div>
                                {memoInfo?.TipoInformativo === 1 && <div>
                                    <h5 style={{ textAlign: 'center' }}>Programación de Transporte</h5>
                                </div>}

                                {memoInfo?.TipoInformativo === 2 && <div>
                                    <h5 style={{ textAlign: 'center' }}>Menu de la semana</h5>
                                </div>}

                                <div id='toPDF'>
                                </div>
                            </div>

                            <p style={{ marginBottom: 10, ...styles.text }}>
                                {memoInfo.Conclusion ? memoInfo.Conclusion : ''}
                            </p>
                        </div>

                        {/* FIRMAS */}
                        <div>
                            <div style={styles.firmaContainer}>
                                {firma.map(f => {
                                    return <div key={f.idpersonal} style={styles.firmaItem}>
                                        {f?.firma.length > 0 ? <img style={styles.imgFirma} src={f.firma[0].firma} alt='' /> : <span style={styles.imgFirma}></span>}
                                        <div style={{ fontWeight: 800, fontSize: 14, fontFamily: 'Times-Roman', ...styles.firmaNombre }}>{f?.NombreEmpleado.toLowerCase()}</div>
                                        <div style={styles.firmaNombre}>{f?.posicion.toLowerCase() + ' de ' + f?.seccion.toLowerCase()}</div> 
                                        {/* <div style={styles.firmaNombre}>{f?.seccion.toLowerCase()}</div> */}
                                    </div>
                                })}

                                {/* <div style={styles.firmaContainer}>
                                    {memoInfo?.PermisoPresidencia && <div style={styles.firmaItem}>
                                        <img style={styles.imgFirma} src={RobertoB} alt='' />
                                        <div style={{ ...styles.firmaNombre, fontWeight: 800, fontSize: 14, fontFamily: 'Times-Roman', color: '#000' }}>Roberto Bueso Araujo</div>
                                        <div style={styles.firmaNombre}>Presidente</div>
                                    </div>}
                                </div> */}

                            </div>
                        </div>

                    </div>
                </div>) : 'No se encontró el memorándum.'}

            </div>

        </div>
    )
}

export default ComunicadoPDF